import React from 'react';

export function Topbar({ title, description, onRefresh, refreshing }) {
  return (
    <header className="topbar">
      <div>
        <span className="eyebrow">Perifa Pro ao vivo</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <button className="refresh-button" onClick={onRefresh} disabled={refreshing}>
        {refreshing ? 'Atualizando...' : 'Atualizar'}
      </button>
    </header>
  );
}
